import React from 'react';
import { FieldComponentTypes, FormField } from '@dtp/membership-service-types';
import { Controller, UseFormReturn } from 'react-hook-form';
import S from './Styles';
import { FormFieldErrorMessage } from './FormFieldErrorMessage';
import { FormFieldInput } from './FormFieldInput';
import { useDependentField } from './useDependentField';

export interface FormFieldWithCondition extends FormField {
  dependentFieldCondition?: string;
}

interface FormFieldRenderProps {
  field: FormFieldWithCondition;
  fieldId: string;
  control: UseFormReturn['control'];
  errors: UseFormReturn['formState']['errors'];
  clearErrors?: UseFormReturn['clearErrors'];
  watch?: UseFormReturn['watch'];
  setValue?: UseFormReturn['setValue'];
  extraMargin?: boolean;
}

export const FormFieldRender = ({
  field,
  fieldId,
  control,
  errors,
  clearErrors,
  watch,
  setValue,
  extraMargin = false,
}: FormFieldRenderProps) => {
  const isActive = useDependentField({
    condition: field.dependentFieldCondition,
    fieldId: field.id,
    watch,
    setValue,
    clearErrors,
  });
  if (!isActive) return null;

  return (
    <S.FieldWrapper $isVisible={field.isVisible !== false}>
      <Controller
        rules={{
          required: field.validation?.required?.value,
          minLength: field.validation?.minLength?.value,
          maxLength: field.validation?.maxLength?.value,
          pattern: field.validation?.pattern?.value,
          max: field.validation?.max?.value,
          min: field.validation?.min?.value,
        }}
        name={fieldId}
        control={control}
        defaultValue={field.initialValue}
        render={({ field: { value, onChange, disabled } }) => (
          <>
            {field.component !== FieldComponentTypes.Select && field.component !== FieldComponentTypes.Typeahead && (
              <S.StyledLabel htmlFor={field.id}>{field.label}</S.StyledLabel>
            )}
            <FormFieldInput
              field={field}
              fieldId={fieldId}
              value={value}
              onChange={onChange}
              isDisabled={!!disabled || !!field.isReadOnly}
              errors={errors}
              clearErrors={clearErrors}
              watch={watch}
              setValue={setValue}
              extraMargin={extraMargin}
            />
            <FormFieldErrorMessage field={field} fieldId={fieldId} errors={errors} />
          </>
        )}
      />
    </S.FieldWrapper>
  );
};
